import { createContext } from 'react'

/**
 * Interface for navigation block context value
 */
export interface NavigationBlockContextValue {
  showCancelDialog: boolean
  pendingNavigation: string | null
  triggerNavigationDialog: (targetPath: string) => void
  confirmNavigation: () => void
  cancelNavigation: () => void
}

/**
 * Context for navigation blocking
 */
export const NavigationBlockContext = createContext<
  NavigationBlockContextValue | undefined
>(undefined)
